import "../index.css";
import React from "react";

function Navbar({ onPageChange }) {
  const [page, setPage] = React.useState("about");

  const navItems = [
    { id: "about", label: "About" },
    { id: "experience", label: "Experience" },
    { id: "projects", label: "Projects" },
    { id: "resume", label: "Resume" },
  ];

  const handleClick = (id) => {
    setPage(id);
    onPageChange(id);
  };

  return (
    <nav className="navbar">
      <ul className="navbar-list">
        {navItems.map((item) => (
          <li key={item.id} className="navbar-item">
            <button
              className={`navbar-link ${page === item.id ? "active" : ""}`}
              onClick={() => handleClick(item.id)}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Navbar;